import {
  LOGIN_SUCCESSFUL,
  LOGOUT,
  CHANGED_PASSWORD,
  SET_PUNTOS,
  REFRESH_TOKEN,
} from "../constants";
const storedToken = localStorage.getItem("token") || null;
const storedUserId = localStorage.getItem("userId") || null;
const storedPerfilId = localStorage.getItem("perfil") || null;
const storedNombre = localStorage.getItem("nombre") || null;
const storedApellido = localStorage.getItem("apellido") || null;
const storedUsername = localStorage.getItem("username") || null;
const storedFechaIngreso = localStorage.getItem("fecha_ingreso") || null;
const storedIsProvisional =
  localStorage.getItem("is_clave_provisional") || null;
const storedEmpresaId = localStorage.getItem("empresaId") || null;
const storedPuntos = localStorage.getItem("puntos") || 0;
// Parsea el valor de "is_clave_provisional" a un booleano
const storedIsProvisionalBoolean = storedIsProvisional === "true";
const initialState = {
  token: storedToken,
  userId: storedUserId,
  perfilId: storedPerfilId,
  nombre: storedNombre,
  apellido: storedApellido,
  username: storedUsername,
  is_clave_provisional: storedIsProvisionalBoolean,
  empresaId: storedEmpresaId,
  puntos: storedPuntos,
  fecha_ingreso: storedFechaIngreso,
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESSFUL:
      const {
        token,
        userId,
        perfilId,
        nombre,
        apellido,
        username,
        is_clave_provisional,
        empresaId,
        puntos,
        fecha_ingreso,
      } = action.payload;
      const nombreToSet = nombre !== undefined ? nombre : null;
      const apellidoToSet = apellido !== undefined ? apellido : null;
      const storedEmpresaId = empresaId;
      const parsedEmpresaId =
        storedEmpresaId === "null" || storedEmpresaId === null
          ? null
          : storedEmpresaId;

      // Guardar en localStorage al iniciar sesión
      localStorage.setItem("token", token);
      localStorage.setItem("userId", userId);
      localStorage.setItem("perfil", perfilId);
      localStorage.setItem("nombre", nombreToSet);
      localStorage.setItem("apellido", apellidoToSet);
      localStorage.setItem("username", username);
      localStorage.setItem("is_clave_provisional", is_clave_provisional);
      localStorage.setItem("empresaId", parsedEmpresaId);
      localStorage.setItem("puntos", puntos);
      localStorage.setItem("fecha_ingreso", fecha_ingreso);
      return {
        ...state,
        token: action.payload.token,
        userId: action.payload.userId,
        perfilId: action.payload.perfilId,
        nombre: nombreToSet,
        apellido: apellidoToSet,
        username: username,
        is_clave_provisional: is_clave_provisional,
        empresaId: parsedEmpresaId,
        puntos: action.payload.puntos,
        fecha_ingreso: fecha_ingreso,
      };
    case LOGOUT:
      // Limpiar localStorage al cerrar sesión
      //localstorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("perfil");
      localStorage.removeItem("nombre");
      localStorage.removeItem("apellido");
      localStorage.removeItem("username");
      localStorage.removeItem("is_clave_provisional");
      localStorage.removeItem("empresaId");
      localStorage.removeItem("puntos");
      localStorage.removeItem("fecha_ingreso");
      return {
        ...state,
        token: null,
        userId: null,
        perfilId: null,
        nombre: null,
        apellido: null,
        username: null,
        is_clave_provisional: null,
        empresaId: null,
        puntos: 0,
        fecha_ingreso: null,
      };
    case CHANGED_PASSWORD:
      const is_provisional = false;
      localStorage.setItem("is_clave_provisional", is_provisional);
      return {
        ...state,
        is_clave_provisional: is_provisional,
      };
    case SET_PUNTOS:
      localStorage.setItem("puntos", action.payload);
      return {
        ...state,
        puntos: action.payload,
      };

    case REFRESH_TOKEN:
      const { newToken } = action.payload;

      localStorage.setItem("token", newToken);
      return {
        ...state,
        token: newToken,
      };
    default:
      return state;
  }
};

export default authReducer;
